module.exports = __webpack_public_path__ + "static/media/sg10cr538.0a169ae9.png";